// Hooks de Administración · Contratistas (T-0qrc). Misma nómina que el
// drawer de asignación (/providers) bajo la clave de la sección, como
// enlaces/queries.ts. Cada escritura invalida además la clave global
// `queryKeys.providers`: el AssignDrawer y la pantalla de postventa
// siguen vivos en la misma sesión y tienen que ver el nombre nuevo o al
// contratista pausado sin recargar.

import { useMutation, useQuery, useQueryClient, type QueryClient } from "@tanstack/react-query";
import type { ProviderCreateBody, ProviderPatchBody } from "@bitacorapro/api-types";
import { queryKeys } from "../../../lib/api/queries";
import { contratistasApi } from "./api";

export const contratistasQueryKeys = {
  list: ["administracion", "contratistas"] as const,
} as const;

function invalidateNomina(qc: QueryClient): void {
  void qc.invalidateQueries({ queryKey: contratistasQueryKeys.list });
  void qc.invalidateQueries({ queryKey: queryKeys.providers });
}

// Apagada para quien no administra: GET /providers responde 403 a un rol
// sin carril de asignación, y la guarda de App.tsx ya redirige antes.
export function useContratistas(enabled = true) {
  return useQuery({
    queryKey: contratistasQueryKeys.list,
    queryFn: () => contratistasApi.list(),
    enabled,
  });
}

export function useCrearContratista() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ProviderCreateBody) => contratistasApi.create(body),
    onSuccess: () => invalidateNomina(qc),
  });
}

export function usePatchContratista() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ProviderPatchBody }) =>
      contratistasApi.patch(id, body),
    onSuccess: () => invalidateNomina(qc),
  });
}
